import {includes, keyBy} from 'lodash';
import {EARNING_STATUSES} from 'shared/utils';

export const ALL = 'all';
export const EARNING = 'earning';
export const NOT_EARNING = 'not earning';
export const BOOST_GPA = 'boost gpa';
export const SAFETY = 'safety';
export const TARGET = 'target';
export const REACH = 'reach';

const BASE_FILTERS = [ALL, EARNING, NOT_EARNING, BOOST_GPA];

const BYL_FILTERS = [SAFETY, TARGET, REACH];

const hasScoreCategory =
  (category) =>
  ({admissionLikelihoodScoreCategory}) =>
    admissionLikelihoodScoreCategory === category;

const isEarning = ({earningRelationship: {statusType}}) => includes(EARNING_STATUSES, statusType);

const needsGPABoost = ({earningRelationship: {statusType}}) => statusType === 'boost_gpa';

export const FILTERS = [
  {name: ALL, label: 'View: All', filter: () => true},
  {name: EARNING, label: 'Earning', filter: isEarning},
  {name: BOOST_GPA, label: 'Boost GPA', filter: needsGPABoost},
  {name: NOT_EARNING, label: 'Not Earning', filter: (earning) => !isEarning(earning)},
  {name: SAFETY, label: 'Safety', filter: hasScoreCategory(SAFETY)},
  {name: TARGET, label: 'Target', filter: hasScoreCategory(TARGET)},
  {name: REACH, label: 'Reach', filter: hasScoreCategory(REACH)},
];

export const EARNING_FILTERS = keyBy(FILTERS, 'name');

export const orderedFilters = (includeBYL) => {
  if (includeBYL) {
    return [...BASE_FILTERS, ...BYL_FILTERS];
  }
  return BASE_FILTERS;
};

export const earningFilterOptions = ({filters, itemCounts}) =>
  filters.map((filterName) => {
    const count = itemCounts[filterName];
    const name = EARNING_FILTERS[filterName].label;
    const text = filterName === ALL ? name : `${name} (${count})`;
    const disabled = count === 0;
    return {
      _id: filterName,
      key: filterName,
      text,
      value: filterName,
      disabled,
    };
  });
